/* eslint-disable no-unused-expressions */

import Map from "react-map-gl";
import { useEffect, useState } from "react";
import maplibregl from "maplibre-gl";
import ButtonComponent from "../elements/ButtonComponent";
import MapPopup from "./componentPopups/MapPopup";

const MapComponent = ({
  setLng,
  setLat,
  lng,
  lat,
  justShow,
  alwaysTopTitle,
  withoutTitle,
  errors,
}: any) => {
  const [preLocationData, setPreLocationData] = useState<boolean>(false);
  const [Llat, setLLat] = useState<any>(35.744186625520584);
  const [Llng, setLLng] = useState<any>(51.3742458287103);
  const [mapp, setMapp] = useState<any>(maplibregl);
  const [changeMap, setChangeMap] = useState<boolean>(false);
  const maptilerKey = "D6FQRICPdD7utxJPkNXC";

  useEffect(() => {
    if (lat !== null && lat !== undefined) setPreLocationData(true);
  }, [lat]);

  const showInMapClicked = () =>
    window.open("https://maps.google.com?q=" + lat + "," + lng);

  function onClose() {
    setChangeMap(false);
  }

  return (
    <>
      <div className="flex flex-col w-full items-start justify-center gap-2">
        {justShow ? (
          <>
            {lat !== undefined && lat !== null ? (
              <>
                <div
                  onClick={showInMapClicked}
                  className={`flex gap-2 ${
                    alwaysTopTitle
                      ? `flex-col`
                      : `max-sm:flex-col sm:flex-row md:flex-row lg:flex-row`
                  } cursor-pointer w-full items-start justify-start`}
                >
                  {!withoutTitle ? (
                    <p className="text-gray-400 text-BodyText/12/Regular">
                      موقعیت مکانی:
                    </p>
                  ) : null}
                  <div className="flex max-sm:w-[250px] sm:w-[370px] md:w-[370px] lg:w-[370px] h-[150px] relative justify-center items-center rounded-lg">
                    <div className="flex w-full h-[150px] bottom-0 right-0 pointer-events-none justify-center items-center rounded-lg overflow-hidden">
                      <Map
                        mapLib={mapp}
                        initialViewState={{
                          latitude: lat,
                          longitude: lng,
                          zoom: 12,
                        }}
                        mapStyle={`https://api.maptiler.com/maps/streets/style.json?key=${maptilerKey}`}
                      ></Map>
                      <img
                        className=" absolute flex z-10 right-auto max-sm:top-[56px] sm:top-[56px] md:top-[56px] lg:top-[56px]"
                        src="/icons/marker-blue.svg"
                        alt="not found"
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex justify-center items-center px-2.5 py-1 border border-yellow-300 bg-yellow-50 rounded-lg">
                <p className="text-yellow-600 text-BodyText/14/Medium">
                  اطلاعات موقعیت مکانی ثبت نشده است
                </p>
              </div>
            )}
          </>
        ) : (
          <>
            <p className="text-gray-900 text-IRANYekanXFaNum">
              موقعیت مکانی فروشگاه <span className="text-red-600">*</span>
            </p>
            {lat === null || lat === undefined ? (
              <>
                <div
                  className={`flex flex-col w-full justify-center items-center gap-1 px-auto py-14 ${
                    errors
                      ? errors?.lat || errors?.lng
                        ? `bg-red-100 border-red-300`
                        : `bg-gray-50 border-gray-200`
                      : `bg-gray-50 border-gray-200`
                  }  border-[2px] border-dashed rounded-lg  `}
                >
                  <img src="/icons/marker-gray.svg" alt="marker-gray" />
                  <p className="text-gray-600 text-BodyText/14/Regular">
                    برای انتخاب موقعیت مکانی کلیک کنید
                  </p>
                  <ButtonComponent
                    onClick={() => setChangeMap(true)}
                    className="mt-1"
                  >
                    انتخاب موقعیت مکانی
                  </ButtonComponent>
                </div>
              </>
            ) : (
              <>
                <div
                  onClick={() => setChangeMap(true)}
                  className="flex w-full h-[200px] relative justify-center cursor-pointer items-center  rounded-lg overflow-hidden"
                >
                  <div className="flex w-full z-1 h-[200px] relative bg-gray-500 opacity-50  rounded-lg"></div>
                  <div className="flex w-full absolute h-[200px] bottom-0 right-0 pointer-events-none justify-center items-center rounded-lg overflow-hidden">
                    <Map
                      mapLib={mapp}
                      initialViewState={{
                        latitude: lat,
                        longitude: lng,
                        zoom: 12,
                      }}
                      mapStyle={`https://api.maptiler.com/maps/streets/style.json?key=${maptilerKey}`}
                    ></Map>
                    <img
                      className=" absolute z-[2] right-auto flex max-sm:top-[76px] sm:top-[76px] md:top-[76px] lg:top-[76px]"
                      src="/icons/marker-blue.svg"
                      alt="not found"
                    />
                  </div>
                  <ButtonComponent className="flex z-[3] opacity-100 absolute top-[80px] right-auto">
                    تغییر موقعیت مکانی
                  </ButtonComponent>
                </div>
              </>
            )}
          </>
        )}

        {changeMap ? (
          <MapPopup
            onClose={onClose}
            lat={lat}
            lng={lng}
            setLat={setLat}
            setLng={setLng}
            Llat={Llat}
            Llng={Llng}
            maptilerKey={maptilerKey}
            preLocationData={preLocationData}
          />
        ) : null}
      </div>
    </>
  );
};

export default MapComponent;
